import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleModal } from 'apps/promo/actions/appAction';
import { getCurrentLang } from 'apps/promo/helpers/utils';
import clsx from 'clsx';

import styles from './Footer.module.css';
import { PromoText } from '../common/promo-text/PromoText';
import PromoLanguages from '../utils/PromoLanguages';

const FooterLang = (props) => {
    const langClass = clsx(styles.footerLang, {
        [styles.footerLangBlack]: props.promoDarkPage,
    });

    const languages = props.noAuthFooter?.language?.languages;
    const lang = props.noAuthFooter?.language?.lang;
    const country = props.noAuthFooter?.language?.country;

    return (
        <div className={styles.languageLabel}>
            <PromoText
                tag="div"
                data-testid="footer-lang-link-language"
                onClick={() =>
                    props.toggleModal(
                        true,
                        <PromoLanguages
                            lang={lang}
                            languages={languages}
                            title={props.siteLanguageTitle}
                            country={country}
                            isLanding={props.isLanding}
                            isRequest={props.isRequest}
                        />,
                    )
                }
                onKeyPress={() =>
                    props.toggleModal(
                        true,
                        <PromoLanguages
                            lang={lang}
                            languages={languages}
                            title={props.siteLanguageTitle}
                            country={country}
                            isLanding={props.isLanding}
                            isRequest={props.isRequest}
                        />,
                    )
                }
                tabIndex={'0'}
            >
                <a className={langClass}>
                    <span>{languages && Array.isArray(languages) ? getCurrentLang(languages, lang) : ''}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="24" height="24">
                        <path
                            d="m7 10 5 5 5-5"
                            fill="none"
                            stroke={props.promoDarkPage ? '#A7A7A7' : '#4e4e4e'}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.4"
                        />
                    </svg>
                </a>
            </PromoText>
        </div>
    );
};

FooterLang.propTypes = {
    lang: PropTypes.string,
    languages: PropTypes.arrayOf(
        PropTypes.shape({
            locale: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        }),
    ),
};

const mapStateToProps = (state) => {
    return {
        siteLanguageTitle: state.extra.noAuthFooter?.language?.siteLanguageTitle,
        noAuthFooter: state.extra.noAuthFooter,
    };
};

export default connect(mapStateToProps, { toggleModal })(FooterLang);
